import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import Audio from 'components/bolt/audio/audio';
// import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {

	render(props, state) {
		const urlRoots = props?.initialStore?.appData?.urls?.roots || {};
		const mediaRoot = urlRoots.media || '';
		const sharedImageRoot = urlRoots.sharedImages || '';
		const audioRoot = `https://dx35vtwkllhj9.cloudfront.net/obAwQu8A4`;
		const audioComp = <Audio audioRoot={audioRoot} sharedImageRoot={sharedImageRoot} />;
		const base = super.render(props, state);
		base.children.push(audioComp);
		return base;
	}
}